import { useLocation } from 'react-router-dom';
import { CRUISE_ROUTES } from '../constants/cruiseConstants';
import { buildSearchQuery } from './cruiseUtils';

/**
 * The cruise flow keeps nothing in localStorage / sessionStorage.
 *
 * The search lives in the results URL (like flight / hotel / bus), so a
 * results page is always fetched fresh from its query string. Everything
 * picked after that (cruise, fare, category, cabin, bed, dining, the price
 * check, typed guest details) travels to the next page in react-router
 * navigation state. The browser keeps that state with the history entry,
 * so Back and refresh still work, and a new tab or a typed URL starts
 * clean from search.
 */

/** Order of the slices; a step only forwards the slices before it. */
const FLOW_KEYS = [
  'search',
  'cruise',
  'fare',
  'category',
  'cabin',
  'bed',
  'dining',
  'priceCheck',
];

/** The flow state the current page was opened with. */
export const useCruiseFlow = () => useLocation().state || {};

/**
 * State for the next step: every slice up to and including `upTo` from
 * `flow`, plus `patch`. Typed guest details are always carried along so
 * going back a step and forward again keeps them.
 */
export const flowUpTo = (flow, upTo, patch = {}) => {
  const last = FLOW_KEYS.indexOf(upTo);
  const next = {};
  FLOW_KEYS.slice(0, last + 1).forEach((k) => {
    if (flow[k] !== undefined) next[k] = flow[k];
  });
  if (flow.guests) next.guests = flow.guests;
  return { ...next, ...patch };
};

export const resultsUrl = (search) =>
  `${CRUISE_ROUTES.RESULTS}?${buildSearchQuery(search || {})}`;
